import React from "react";

export default function Section({ boldText, children }) {
  return (
    <section className="relative mx-auto flex max-w-screen-xl flex-col items-center px-5 my-16">
      <h2 className="mb-5 text-center text-3xl font-bold tracking-tight lg:text-4xl">
        {boldText}
      </h2>
      {children}
    </section>
  );
}
